/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Mentions_Link_SuccessInputs */



/**
* | output |
* | --- |
* | "\"{name}\" is now linked to this project." |
*
* @param {Chat_Mentions_Link_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_link_success = /** @type {((inputs: Chat_Mentions_Link_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Link_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`„${i?.name}“ ist jetzt mit diesem Projekt verknüpft.`)
	return /** @type {LocalizedString} */ (`"${i?.name}" is now linked to this project.`)
});